import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { Dial } from '.'

const dialSize = size => {
  if (!size) return 18
  if (size === 'lg' || size === 'large') return 22
  if (size === 'sm' || size === 'small') return 16
  if (size === 'xs' || size === 'xsmall') return 14
}

class ButtonProgress extends React.Component {
  render() {
    const { bsStyle, bsSize, className, loading, progress, error, onClick } = this.props

    return (
      <Button bsSize={bsSize} bsStyle={bsStyle} className={className} onClick={onClick}>
        { loading && <Dial size={dialSize(this.props.bsSize)} value={progress} textColor='#444' fgColor='red' bgColor='lightblue'/> }
        { error ? error : this.props.children }
      </Button>
    )
  }
}

ButtonProgress.defaultProps = {
  bsStyle: 'default',
  error: 'Aborted'
}

ButtonProgress.propTypes = {
  bsStyle: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'default']),
  bsSize: PropTypes.oneOf(['lg','large','sm','small','xs','xsmall']),
  error: PropTypes.string
}

export default ButtonProgress



// WEBPACK FOOTER //
// ./src/components/widgets/ButtonProgress.js